module.exports = __webpack_public_path__ + "img/paraglider_black.89aef19a.png";